var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
meedy.factory('meedy.tawkToModel', ['$rootScope', 'meedy.baseModel', 'meedy.userModel', 'meedyConfig',
    function ($rootScope, baseModel, userModel, config) {

        function TawkToModel() {

            var tawkIsAlreadySet = false;

            this.setTawkTo = function () {
                if (!tawkIsAlreadySet) {
                    initializeTawk();
                }
            };

            this.setMessageUser = function (user) {
                userModel.getCurrentUserTawkToken().then(function (keyData) {
                    if(keyData.token) {
                        Tawk_API.setAttributes({
                                'name': user.firstName + ' ' + user.lastName,
                                'email': user.email,
                                'hash': keyData.token
                            },
                            function (error) {
                            }
                        );
                    }
                });
            };

            this.endChat = function () {
                if(Tawk_API.endChat) {
                    Tawk_API.endChat();
                }
            };

            function initializeTawk() {
                if (_.get(config, 'TAWK_TO.KEY')) {
                    embedTawkTo();
                }
            }

            function embedTawkTo() {

                var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
                s1.async = true;
                s1.src = 'https://embed.tawk.to/' + config.TAWK_TO.KEY + '/default';
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                s0.parentNode.insertBefore(s1, s0);

                tawkIsAlreadySet = true;
            }

        }

        return new TawkToModel();
    }
]);
